module.exports = __webpack_public_path__ + "static/img/18.082fdd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcco/18.png
// module id = BRxC
// module chunks = 0